import { NavigateFunction, NavigateOptions, useNavigate, useLocation } from 'react-router-dom';
import { useAuth0 } from '../services/auth0/react-auth0.spa';
import { NavigationDestination } from '../helpers/navigation';
import { useCallback } from 'react';
import { debugLog } from 'shared/logger/debugLog';

export function useRedirectToBrowseInspectionTemplates(): () => void {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth0();
  return useCallback((): void => {
    redirectTo(
      NavigationDestination.browseInspectionTemplates,
      navigate,
      location,
      isAuthenticated
    );
  }, [navigate, location, isAuthenticated]);
}

export function useRedirectToIssueTable(): () => void {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated } = useAuth0();
  return (): void => {
    redirectTo(NavigationDestination.issues, navigate, location, isAuthenticated);
  };
}

export function useRedirect(): (path: string, options?: NavigateOptions) => void {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth0();
  return (path: string, options?: NavigateOptions): void => {
    if (!isAuthenticated) {
      debugLog('useRedirect: user is not authenticated ', isAuthenticated);
      return navigate('/login', options);
    }
    return navigate(path, options);
  };
}

function redirectTo(
  navigationDestination: NavigationDestination,
  navigate: NavigateFunction,
  location: ReturnType<typeof useLocation>,
  isAuthenticated?: boolean
): void {
  if (!isAuthenticated) {
    debugLog('redirectTo: user is not authenticated ', isAuthenticated);
    const redirectLink = `${location.pathname}${location.search}`;
    return navigate('/login', { state: { targetUrl: redirectLink } });
  }
  switch (navigationDestination) {
    case NavigationDestination.issues:
      return navigate(`/issue`);
    case NavigationDestination.browseInspectionTemplates:
      return navigate(`/inspectionTemplate`);
    case NavigationDestination.browseInspections:
      return navigate(`/inspection`);
    default:
      return navigate(`/${navigationDestination}`);
  }
}
